import { InjectionToken } from '@angular/core';
import type { Inputs } from '@simlab/simlab-facility-management/scene-object';

export type TagTooltipData<TData = Inputs['userData']> = {
  id: string;
  userData: TData;
};

/**
 * Injected into tooltip content rendered from a component (`TooltipConfiguration.component`),
 * so the content can read the hovered tag `id` and `userData` without declaring inputs.
 *
 * @example
 * readonly data = inject(TAG_TOOLTIP_DATA);
 */
export const TAG_TOOLTIP_DATA = new InjectionToken<TagTooltipData>(
  'Simlab tag tooltip data'
);
